var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvince(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 640 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(15.590106,0,0,15.590106,-5923.8342,-5987.5622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 400.06,392.97 c 2.141,0 3.862,1.61 3.862,3.751 0,2.055 -1.721,3.768 -3.862,3.768 -2.158,0 -3.879,-1.713 -3.879,-3.768 0,-2.141 1.721,-3.751 3.879,-3.751 z m 9.667,2.791 c 0,-5.258 -4.298,-9.454 -9.667,-9.454 -5.378,0 -9.788,4.196 -9.788,9.454 0,0.223 0,0.548 0.111,0.753 h -0.111 c 0,5.155 9.788,17.058 9.788,17.058 0,0 9.667,-11.902 9.667,-17.058 v 0 c 0,-0.204 0,-0.53 0,-0.753 z",
    clipRule: "evenodd",
    fillRule: "evenodd",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvince);
export default __webpack_public_path__ + "static/media/province.52a8449657751183c4daa8974edf6c3a.svg";
export { ForwardRef as ReactComponent };